import { getCubeId } from '@core/core/helpers'
import { getCubeLineForTab, updateCubeLineValueByLineType, useAppDispatch } from '@core/core/store'
import type { ActiveEntity } from '@core/core/types'
import type { ChannelMessage } from 'common/messenger'
import { messengerRef } from 'common/messenger'
import type { CubeId, ProjectId, TabId } from 'common/types'
import deepEqual from 'fast-deep-equal'
import { useEffect, useState } from 'react'

export const useCubeLine = (
  entities: ActiveEntity[],
  tabId: TabId,
  projectId: ProjectId,
  isCurrentlyActive: boolean,
) => {
  const [cubesIds, setCubesIds] = useState<CubeId[]>([])
  const dispatch = useAppDispatch()

  useEffect(() => {
    const initialCubeIds: CubeId[] = []
    const actualCubesIds = entities
      .filter(entity => entity.entityType === 'cube')
      .reduce((acc, cube) => {
        const id = getCubeId(cube)
        if (id) {
          acc.push(id)
        }
        return acc
      }, initialCubeIds)
    if (!deepEqual(cubesIds, actualCubesIds)) {
      setCubesIds(actualCubesIds)
    }
  }, [entities])

  useEffect(() => {
    if (cubesIds.length) {
      dispatch(getCubeLineForTab(cubesIds, projectId, tabId))
    }
  }, [cubesIds])

  useEffect(() => {
    function updateCubeLineValueHandler({
      payload: { cubeId, value, lineType },
    }: ChannelMessage<'updateCubeLineValue'>) {
      if (isCurrentlyActive) {
        dispatch(updateCubeLineValueByLineType(lineType, projectId, tabId, cubeId, value))
      }
    }

    const unsubscribe = messengerRef.current?.subscribe(
      'updateCubeLineValue',
      updateCubeLineValueHandler,
    )

    return unsubscribe
  }, [isCurrentlyActive, tabId, projectId])
}
